import {
  IBuyerSearchInvoiceRes,
  IBuyerSearchInvoiceReq,
  IBuyerAcceptInvoice,
  IBuyerSearchBillingRes,
  IBuyerSearchBillingReq,
  IBuyerSearchBilling,
  IBuyerSearchPaymentReq,
  IBuyerSearchPaymentRes,
  IBuyerSearchPayment,
  IBuyerAcceptInvoiceRes,
  IBuyerAcceptanceBillingRes,
} from '@/interfaces/buyer';
import * as baseAdapter from './baseAdapter';

export const searchBuyerInvoice = async (req: IBuyerSearchInvoiceReq) => {
  const ret = await baseAdapter.post<IBuyerSearchInvoiceRes>(
    '/v1/buyer/invoice/inquiry',
    req
  );
  return ret;
};

export const invoiceAcceptance = async (req: IBuyerAcceptInvoice) => {
  const ret = await baseAdapter.post<any>('/v1/buyer/invoice/acceptance', req);
  return ret;
};

export const invoiceAcceptances = async (req: IBuyerAcceptInvoice[]) => {
  const ret = await baseAdapter.post<IBuyerAcceptInvoiceRes>(
    '/v1/buyer/invoice/acceptances',
    req
  );
  return ret;
};

export const searchBuyerBilling = async (req: IBuyerSearchBillingReq) => {
  const ret = await baseAdapter.post<IBuyerSearchBillingRes>(
    '/v1/buyer/presentment/inquiry',
    req
  );
  return ret;
};

export const billingAcceptance = async (req: Partial<IBuyerSearchBilling>) => {
  const ret = await baseAdapter.post<any>(
    '/v1/buyer/presentment/acceptance',
    req
  );
  return ret;
};

export const billingAcceptances = async (
  req: Partial<IBuyerSearchBilling>[]
) => {
  const ret = await baseAdapter.post<IBuyerAcceptanceBillingRes>(
    '/v1/buyer/presentment/acceptances',
    req
  );
  return ret;
};

export const searchSellerAccounts = async (vendor: string) => {
  const ret = await baseAdapter.post<any>('/v1/buyer/seller-account/inquiry', {
    vendor: vendor,
  });
  return ret;
};

export const searchBuyerPayment = async (req: IBuyerSearchPaymentReq) => {
  const ret = await baseAdapter.post<IBuyerSearchPaymentRes>(
    '/v1/buyer/payment/inquiry',
    req
  );
  return ret;
};

export const paymentEntry = async (req: Partial<IBuyerSearchPayment>) => {
  const ret = await baseAdapter.post<any>('/v1/buyer/payment/entry', req);
  return ret;
};
